import { UPGRADES } from "../../lib/game/content";
import {
  NEWS_SCENE_CAPTIONS,
  reportForNotice,
  reportRegion,
} from "../../lib/game/news";
import type { NewsItem } from "../../lib/game/types";
import { upgradeArtwork, upgradeNarrative } from "./upgrade-story";
import { newsArtwork, newsBroadcast } from "./news-art";

export interface NewsEditorial {
  headline: string;
  section: string;
  source: string;
  body: string;
  image: string;
  caption: string;
  region?: string;
  thread?: string;
  broadcast?: { station: string; label: string };
}

/** The saved publication is authoritative; no live projection is consulted. */
export function newsEditorial(item: NewsItem): NewsEditorial {
  const report = item.report ?? reportForNotice(item.headline, item.detail);
  if (report)
    return {
      headline: report.headline,
      section: report.section,
      source: report.source,
      body: report.body,
      image: newsArtwork(report),
      broadcast: newsBroadcast(report),
      caption: `Illustration · ${NEWS_SCENE_CAPTIONS[report.scene]}`,
      region: reportRegion(report),
      thread: report.thread,
    };
  const upgrade = UPGRADES.find((u) =>
    ["BUILD STARTED", "ONLINE", "UNLOCKED", "ACTIVATED"].some(
      (status) => item.headline === `${u.name.toUpperCase()} ${status}`,
    ),
  );
  if (upgrade)
    return {
      headline: item.headline,
      section: "Operations",
      source: "Operations log",
      body: `${upgradeNarrative[upgrade.id]}${item.detail ? ` ${item.detail}` : ""}`,
      image: upgradeArtwork(upgrade.id),
      caption: `Illustration · ${upgrade.name}`,
    };
  return {
    headline: item.headline,
    section: "Archive",
    source: "Campaign archive",
    body:
      item.detail ??
      "The original headline and issue date are preserved in the campaign record.",
    image: "/art/news/archive.jpg",
    caption: "Illustration · Autonomous infrastructure",
  };
}
